export default "__VITE_ASSET__B6SCPEc1__"